module.exports = __webpack_public_path__ + "img/products_big_can_berrybloom.e9a7bfa7.png";